import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Recensioni e Opinioni Italiane su Itaobuy Spreadsheet',
  url: `${siteUrl}/itaobuy-recensioni`,
  description: 'Leggi le recensioni itaobuy degli utenti italiani: esperienze reali, opinioni e consigli dalla community.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function RecensioniPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ RECENSIONI</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Recensioni e Opinioni Italiane su Itaobuy Spreadsheet
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Leggi le <strong className="text-background-50">recensioni itaobuy</strong> degli utenti italiani: esperienze reali, opinioni e consigli dalla community.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per esplorare tutti i prodotti recensiti.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Cosa Dicono gli Utenti Italiani</h2>
              <p className="mb-4">Le <strong className="text-foreground-950">recensioni itaobuy degli utenti italiani</strong> sono generalmente molto positive. Gli aspetti più apprezzati includono la completezza del database, la qualità delle foto QC, e il supporto della community. Molti utenti segnalano un'esperienza di acquisto fluida e prodotti conformi alle descrizioni.</p>
              <p>Per un confronto con altre piattaforme, leggi <Link to="/itaobuy-vs-alternative" className="text-primary-600 font-medium hover:underline">itaobuy vs alternative</Link>.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Vantaggi Segnalati dalla Community</h2>
              <ul className="space-y-2 list-disc pl-5 mb-4">
                <li><strong className="text-foreground-950">Database Organizzato</strong>: Categorie chiare e prodotti ben catalogati</li>
                <li><strong className="text-foreground-950">Aggiornamenti Costanti</strong>: Nuovi prodotti aggiunti ogni settimana</li>
                <li><strong className="text-foreground-950">Supporto Italiano</strong>: Community attiva che condivide consigli in italiano</li>
                <li><strong className="text-foreground-950">Rapporto Qualità-Prezzo</strong>: Prodotti di buona qualità a prezzi competitivi</li>
              </ul>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Unisciti alla Community</h3>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">Recensioni itaobuy italiane</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}